'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var axios = require('axios');
var tslib = require('tslib');
var createAuthRefreshInterceptor = require('axios-auth-refresh');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var createAuthRefreshInterceptor__default = /*#__PURE__*/_interopDefaultLegacy(createAuthRefreshInterceptor);

var getCSRFToken = function getCSRFToken() {
  var _a;
  return (_a = ocm === null || ocm === void 0 ? void 0 : ocm.config) === null || _a === void 0 ? void 0 : _a.CSRFToken;
};
var setCSRFToken = function setCSRFToken(token) {
  ocm.config.CSRFToken = token;
};
var csrfHandler = function csrfHandler(failedRequest) {
  var _a, _b;
  var token = (_a = failedRequest === null || failedRequest === void 0 ? void 0 : failedRequest.response) === null || _a === void 0 ? void 0 : _a.headers["csrftoken"];
  token && setCSRFToken(token);
  if (((_b = failedRequest.response) === null || _b === void 0 ? void 0 : _b.config.headers) && token) {
    failedRequest.response.config.headers["CSRFToken"] = token;
  }
  return Promise.resolve();
};

var HTTP_PRECONDITION_FAILED = 412;
var $axios = axios__default['default'].create({
  baseURL: currentContextPath
});
var $axiosRefresh = axios__default['default'].create({
  baseURL: currentContextPath
});
createAuthRefreshInterceptor__default['default']($axios, csrfHandler, {
  statusCodes: [HTTP_PRECONDITION_FAILED],
  pauseInstanceWhileRefreshing: true,
  retryInstance: $axiosRefresh
});
$axios.interceptors.request.use(function (config) {
  config.__retryCount = config.__retryCount || 0;
  return config;
});
$axios.interceptors.response.use(function (response) {
  return response;
},
// eslint-disable-next-line complexity
function (error) {
  return tslib.__awaiter(void 0, void 0, void 0, function () {
    var config, token;
    var _a;
    return tslib.__generator(this, function (_b) {
      config = error.config;
      token = (_a = error.response) === null || _a === void 0 ? void 0 : _a.headers["csrftoken"];
      token && setCSRFToken(token);
      if (config && config.headers && token) {
        config.headers["CSRFToken"] = token;
      }
      if (config && error.response && error.response.status === HTTP_PRECONDITION_FAILED && config.__retryCount < 3) {
        config.__retryCount += 1;
        // Retry the request
        return [2 /*return*/, $axios(config)];
      }
      return [2 /*return*/, Promise.reject(error)];
    });
  });
});

var URL_PARAM_LENGTH_LIMIT = 1200;
var isAuthenticationError = function isAuthenticationError(errorCode) {
  return [401, 403].includes(errorCode);
};
var getCurrentUrlWithoutContextPath = function getCurrentUrlWithoutContextPath() {
  var url = window.location.pathname.replace(currentContextPath, "");
  // reduce Request header length
  if (window.location.search.length > URL_PARAM_LENGTH_LIMIT) {
    return url;
  }
  return url + window.location.search;
};
var handleAuthenticationRedirect = function handleAuthenticationRedirect(error) {
  var _a, _b, _c;
  if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) && isAuthenticationError(error.response.status)) {
    var url = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.redirectUrl;
    window.location = url || "".concat(currentContextPath, "/my-account/sign-in/");
  }
};
var handleErrorWithRedirect = function handleErrorWithRedirect(axiosError) {
  var _a, _b;
  if (!((_a = axiosError.config) === null || _a === void 0 ? void 0 : _a.handleErrorWithRedirect)) {
    return;
  }
  var statusCode = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.status;
  if (statusCode === 500) {
    window.location.replace("".concat(currentContextPath, "/error/500/"));
  }
  if (statusCode === 404) {
    window.location.replace("".concat(currentContextPath, "/error/404/"));
  }
};

var currentExecutingCancellableRequests = {};
var handleCancellableResponse = function handleCancellableResponse(token) {
  if (!token) {
    return;
  }
  var key = Object.keys(currentExecutingCancellableRequests).find(function (key) {
    return currentExecutingCancellableRequests[key].token === token;
  });
  if (key) {
    delete currentExecutingCancellableRequests[key];
  }
};
var handleCancellableRequest = function handleCancellableRequest(request) {
  var cancelUniqId = request.cancelToken;
  if (currentExecutingCancellableRequests[cancelUniqId]) {
    var source = currentExecutingCancellableRequests[cancelUniqId];
    delete currentExecutingCancellableRequests[cancelUniqId];
    source.cancel("canceled");
  }
  if (cancelUniqId) {
    var CancelToken = axios__default['default'].CancelToken;
    var source = CancelToken.source();
    request.cancelToken = source.token;
    currentExecutingCancellableRequests[cancelUniqId] = source;
  }
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var setHeaders = function setHeaders(request) {
  request.headers = request.headers || {};
  request.headers["X-Requested-With"] = "XMLHttpRequest";
  request.headers["getUrl"] = getCurrentUrlWithoutContextPath();
  request.headers["CSRFToken"] = getCSRFToken();
};
var isCancel = axios__default['default'].isCancel;
$axios.interceptors.request.use(function (request) {
  setHeaders(request);
  handleCancellableRequest(request);
  return request;
});
$axios.interceptors.response.use(function (response) {
  var _a;
  handleCancellableResponse((_a = response.config) === null || _a === void 0 ? void 0 : _a.cancelToken);
  return response;
}, function (error) {
  var _a;
  if (axios__default['default'].isCancel(error)) {
    return Promise.reject(error);
  }
  handleCancellableResponse((_a = error.config) === null || _a === void 0 ? void 0 : _a.cancelToken);
  handleAuthenticationRedirect(error);
  handleErrorWithRedirect(error);
  return Promise.reject(error);
});
// handle createAuthRefreshInterceptor refresh response with unauthorized
$axiosRefresh.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  handleAuthenticationRedirect(error);
  return Promise.reject(error);
});

exports.$axios = $axios;
exports.isCancel = isCancel;
